import { formatConstraintToDropdownValues } from '../utils/commonUtils';
import { orientationOptions, hyperlinkTypes } from './common';
const shortUUiD = require("short-uuid");

export const alertMessaage = "Changes in the id and name cannot be supported. Such changes will make the extension invalid";
export const typeItems = [
    { title: 'Boolean', value: 'BOOL' },
    { title: 'Datetime', value: 'DateTime' },
    { title: 'Double', value: 'double' },
    { title: 'Float', value: 'FLOAT' },
    { title: 'INT8', value: 'INT8' },
    { title: 'INT16', value: 'INT16' },
    { title: 'INT32', value: 'INT32' },
    { title: 'INT64', value: 'INT64' },
    { title: 'JSON', value: 'JSON' },
    { title: 'Octet String', value: 'OCTETSTRING' },
    { title: 'String', value: 'string' },
    { title: 'Struct', value: 'struct' },
    { title: 'Table', value: 'table' },
    { title: 'Table Button', value: 'table-button' },
    { title: 'Timestamp', value: 'TimeStamp' },
    { title: 'UINT8', value: 'UINT8' },
    { title: 'UINT16', value: 'UINT16' },
    { title: 'UINT32', value: 'UINT32' },
    { title: 'UINT64', value: 'UINT64' }
]

export const mediaTypes = [
    { title: 'Image', value: 'image' },
    { title: 'Video', value: 'video' },
    { title: 'Audio', value: 'audio' }
]

export const displayWidgets = [
    { title: 'bar chart', value: 'chart-bar' },
    { title: 'line chart', value: 'chart-line' },
].sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)

export const controls = [
    { title: 'switch', value: 'control-switch' },
    { title: 'slider', value: 'control-slider' },
    { title: 'button', value: 'control-button' },

].sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)


export const otherDisplayTypes = [
    { title: 'Map', value: 'chart-geomap' },
    { title: 'Gauge', value: 'gauge' },
    { title: 'Heatmap', value: 'chart-heatmap' },
    { title: 'Range Plot', value: 'chart-rangeplot' },
    { title: 'Video', value: 'video' },
    { title: 'Counter', value: 'counter' },
    { title: 'Table', value: 'table' },
    { title: 'Image', value: 'image' },
    { title: 'Bar Chart', value: 'chart-bar' },
    { title: 'Line Chart', value: 'chart-line' },
    { title: 'Ratio Bar Chart', value: 'chart-ratiobar' },
    { title: 'Stack Bar Chart', value: 'chart-stackbar' },
    { title: 'Pie Chart', value: 'chart-pie' },
    { title: 'Switch', value: 'control-switch' },
    { title: 'Slider', value: 'control-slider' },
    { title: 'Button', value: 'control-button' },
    { title: '3d Model', value: 'model-3d' },
    { title: '3d Scene', value: 'scene-3d' },
    { title: 'Joystick', value: 'control-joystick' },
    { title: 'Status', value: 'status' },
    { title: 'Scatter Plot', value: 'chart-scatter' },
    { title: 'Compass', value: 'compass' },
    { title: 'Radial Pie', value: 'chart-pie-radial' },
    { title: 'Form', value: 'html_form' },
    // { title: 'Url External', value: 'url-external' },
    // { title: 'Url Clusterlet', value: 'url-clusterlet' },
    // { title: 'Url View', value: 'url-view' },
].sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1)

export const defaultDimensions = {
    "chart-bar": "6x6",
    "chart-geomap": "6x6",
    "chart-heatmap": "6x6",
    "chart-line": "6x6",
    "chart-pie": "6x6",
    "chart-pie-radial": "6x6",
    "chart-rangeplot": "6x6",
    "chart-scatter": "6x6",
    "chart-stackbar": "6x6",
    "chart-ratiobar": "6x6",
    "chat": "6x6",
    "compass": "3x3",
    "control-button": "2x1",
    "control-joystick": "3x3",
    "control-slider": "3x2",
    "control-switch": "2x2",
    "counter": "3x3",
    "gauge": "4x3",
    "html_form": "5x6",
    "image": "5x4",
    "image-map": "5x4",
    "model-3d": "5x5",
    "status": "3x2",
    "string": "3x2",
    "table": "6x6",
    "video": "5x4",
    "scene-3d": "4x4"
};


export const iconValueTypes = ["counter"]
export const unitValueTypes = ["counter", "control-slider", "gauge", "string"]
export const mapValueTypes = ["chart-geomap"]
export const lineChartValueTypes = ["chart-line"]
export const statusValueTypes = ["status"]

export const messageExtensionsRequiredTypes = ['html_form']


export const targetItems = [
    { title: 'url', value: 'url' },
    { title: 'query', value: 'query' },
    { title: 'body', value: 'body' },
]

export const dimensionOptions = [
    { title: '1x1', value: '1x1' },
    { title: '1x2', value: '1x2' },
    { title: '1x3', value: '1x3' },
    { title: '2x1', value: '2x1' },
    { title: '2x2', value: '2x2' },
    { title: '2x3', value: '2x3' },
    { title: '3x3', value: '3x3' },
]

export const dimensionValues = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
]

export const mapTypes = [{ title: 'markers', value: '1' },
{ title: 'waypoint', value: '2' },
{ title: 'track route', value: '3' },
{ title: 'polygon', value: '4' },
];

export const chartTypes = [{ title: 'Straight', value: 'straight' },
{ title: 'Curve', value: 'curve' },

];

export const iconTypes = [
    { title: 'Warning', value: 'warn' },
    { title: 'Success', value: 'success' },
    { title: 'Error', value: 'error' },
    { title: 'Custom Icon', value: 'custom_icon' },
]



export const statusTypes = [
    { title: "Active", value: 'active' },
    { title: "Idle", value: 'idle' },
    { title: "Wait", value: 'wait' }
]


export const typeNumberItems = [
    { title: 'double', value: 'double' },
    { title: "float", value: "FLOAT" },
    { title: 'int8', value: 'INT8' },
    { title: 'int16', value: 'INT16' },
    { title: 'int32', value: 'INT32' },
    { title: 'int64', value: 'INT64' },
    { title: 'uint8', value: 'UINT8' },
    { title: 'uint16', value: 'UINT16' },
    { title: 'uint32', value: 'UINT32' },
    { title: 'uint64', value: 'UINT64' },
];

export const axes = [
    { title: 'X', value: 'x' },
    { title: 'Y', value: 'y' },
]

export const urlItems = [
    { title: 'URL External', value: 'url-external' },
    { title: 'URL Clusterlet', value: 'url-clusterlet' },
    { title: 'URL View', value: 'url-view' },
]

export const defaultValueTypes = ['UINT8', 'UINT16', 'UINT32', 'UINT64',
    'INT8', 'INT16', 'INT32', 'INT64', 'counter', 'FLOAT', 'double', 'DOUBLE', 'OCTETSTRING',
    'string']

export const minValueTypes = ['UINT8', 'UINT16', 'UINT32', 'UINT64',
    'INT8', 'INT16', 'INT32', 'INT64', 'FLOAT', 'double', 'DOUBLE', 'gauge', 'chart-heatmap']

export const minValueTypesForEventType = ['UINT8', 'UINT16', 'UINT32', 'UINT64']

export const maxValueTypes = ['UINT8', 'UINT16', 'UINT32', 'UINT64',
    'INT8', 'INT16', 'INT32', 'INT64', 'FLOAT', 'double', 'DOUBLE', 'gauge', 'chart-heatmap']

export const maxValueTypesForEventType = ['UINT8', 'UINT16', 'UINT32', 'UINT64']

export const unitTypes = ['UINT8', 'UINT16', 'UINT32', 'UINT64', 'FLOAT', 'INT8', 'INT16', 'INT32', 'INT64', 'DOUBLE', 'double', 'gauge', 'string', 'OCTETSTRING']

export const dropdownTypes = ['UINT8', 'UINT16', 'UINT32', 'UINT64', 'INT8', 'INT16', 'INT32', 'INT64', 'FLOAT', 'DOUBLE', 'double', 'OCTETSTRING', 'string', 'BOOL', 'struct', 'table']


export const dimensionTypes = ['chart-rangeplot', 'chart-heatmap', 'chart-bar', 'chart-pie', 'chart-line', 'chart-geomap', 'counter', 'gauge', 'table', 'video', 'image', 'control-switch', 'control-slider', 'control-button', 'model-3d', 'string', 'control-joystick', 'scene-3d', 'status', 'chart-scatter', 'compass', 'chart-pie-radial', 'image-map', 'chart-stackbar', 'chart-ratiobar', 'chat', 'html_form', 'status']

export const orientationTypes = ['control-slider', 'chart-bar', 'chart-stackbar', "html_form"]

export const visibleTypes = ['chart-bar', 'chart-line', 'chart-geomap', 'counter', 'gauge', 'table', 'OCTETSTRING', 'string', 'video', 'UINT8', 'UINT16', 'UINT32', 'UINT64']

export const collectionTypes = ['table', 'struct'];

export const axisTypes = ['chart-bar', 'chart-line', 'chart-rangeplot', 'chart-heatmap', 'chart-pie-radial', 'chart-scatter', 'chart-stackbar', 'chart-ratiobar']

export const axisTypesForMap = ['chart-geomap']

export const validationTypes = ['INT8', 'INT16', 'INT32', 'INT64', 'counter', 'FLOAT', 'double', 'DOUBLE', 'OCTETSTRING',
    'DateTime', 'TimeStamp', 'string']

export const typesForFieldsWithParentChartType = ['UINT8', 'UINT16', 'UINT32', 'UINT64',
    'INT8', 'INT16', 'INT32', 'INT64', 'FLOAT', 'double', 'DOUBLE', 'OCTETSTRING',
    'DateTime', 'TimeStamp', 'string']

export const typesForFieldsWithParentMapType = ['UINT8', 'UINT16', 'UINT32', 'UINT64',
    'INT8', 'INT16', 'INT32', 'INT64', 'FLOAT', 'double', 'DOUBLE', 'OCTETSTRING',
    'DateTime', 'TimeStamp', 'string', 'struct']

export const controlTypes = ['control-switch', 'control-slider', 'control-button', 'control-joystick']
export const actionRequiredTypes = ['table']
export const tableBtn = ['table-button']

export const hyperlinkSupportedTypes = ['image', 'string', 'counter']
export const colorSupportedTypes = ["counter", "string"];
export const hyperlinkNotRequiredType = ['table', 'table-button']

export const displayWithDimension = ['chart-bar', 'chart-rangeplot', 'chart-line', 'chart-pie', 'chart-pie-radial', "chart-scatter", 'chart-stackbar', 'chart-ratiobar', 'chart-heatmap']

export const urlTypes = ['url-external', 'url-clusterlet', 'url-view']

export const mappingTypes = [
    { title: 'Transaction', value: 'transaction' },
    { title: 'Static', value: 'static' },
];

export const mappingFieldTypes = ['UINT8', 'UINT16', 'UINT32', 'UINT64',
    'INT8', 'INT16', 'INT32', 'INT64', 'FLOAT', 'double', 'DOUBLE', 'OCTETSTRING',
    'DateTime', 'TimeStamp', 'string', 'BOOL', 'table', 'url-external', 'url-clusterlet', 'url-view', 'struct'];

export const uiTypeChildren = function () {

    return {
        'gauge': [
            {
                id: shortUUiD.generate(),
                name: 'value',
                type: 'double',
                default: '',
                category: 'field',
                children: []
            },
            {
                id: shortUUiD.generate(),
                name: 'ranges',
                type: 'table',
                collection: true,
                default: [],
                category: 'field',
                children: [
                    {
                        id: shortUUiD.generate(),
                        name: 'low',
                        type: 'double',
                        category: 'field',
                        children: []
                    },
                    {
                        id: shortUUiD.generate(),
                        name: 'high',
                        type: 'double',
                        category: 'field',
                        children: []
                    },
                    {
                        id: shortUUiD.generate(),
                        name: 'color',
                        type: 'string',
                        category: 'field',
                        children: []
                    },
                ]
            }
        ],
        'chart-heatmap': [
            {
                id: shortUUiD.generate(),
                name: 'X',
                desc: '',
                visible: true,
                unit: '',
                axis: 'x',
                infotype: 'info',
                category: 'field',
                type: 'string',
                children: []
            },
            {
                id: shortUUiD.generate(),
                name: 'Y',
                desc: '',
                visible: true,
                unit: '',
                axis: 'y',
                infotype: 'info',
                type: 'string',
                category: 'field',
                children: []
            },
            {
                id: shortUUiD.generate(),
                name: 'data',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'INT32',
                category: 'field',
                children: []
            }
        ],
        'chart-rangeplot': [
            {
                id: shortUUiD.generate(),
                desc: "",
                name: "X",
                visible: true,
                unit: "",
                axis: "x",
                infotype: "info",
                category: "field",
                type: "string",
                children: []
            },
            {
                id: shortUUiD.generate(),
                desc: "",
                name: "Y",
                visible: true,
                unit: "",
                axis: "y",
                infotype: "info",
                type: "struct",
                category: "field",
                children: [
                    {
                        id: shortUUiD.generate(),
                        desc: "",
                        name: "low",
                        visible: true,
                        infotype: "info",
                        type: "UINT32",
                        category: "field",
                        children: []
                    },
                    {
                        id: shortUUiD.generate(),
                        desc: "",
                        name: "high",
                        visible: true,
                        infotype: "info",
                        type: "UINT32",
                        category: "field",
                        children: []
                    }
                ]
            }
        ],
        'chart-line': [
            {
                name: 'X',
                desc: 'X',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y',
                desc: 'Y',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-scatter': [
            {
                name: 'X',
                desc: 'X',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y',
                desc: 'Y',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-bar': [
            {
                name: 'X',
                desc: 'X',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y',
                desc: 'Y',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-ratiobar': [
            {
                name: 'X',
                desc: 'X',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'string',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y',
                desc: 'Y',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-stackbar': [
            {
                name: 'X',
                desc: 'X',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y1',
                desc: 'Y1',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y2',
                desc: 'Y2',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-pie': [
            {
                name: 'X',
                desc: 'X',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'string',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'Y',
                desc: 'Y',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                unit: '',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-geomap': [
            // {
            //     name: 'lat',
            //     desc: 'lat',
            //     visible: true,
            //     axis: 'x',
            //     infotype: 'info',
            //     type: 'double',
            //     id: shortUUiD.generate(),
            //     category: 'field',
            //     children: []
            // },
            // {
            //     name: 'lng',
            //     desc: 'lng',
            //     visible: true,
            //     axis: 'y',
            //     infotype: 'info',
            //     type: 'double',
            //     id: shortUUiD.generate(),
            //     category: 'field',
            //     children: []
            // },
            // {
            //     name: 'field1',
            //     desc: 'field1',
            //     visible: true,
            //     infotype: 'info',
            //     type: 'string',
            //     id: shortUUiD.generate(),
            //     category: 'field',
            //     children: []
            // },
            {
                name: 'coordinates',
                desc: '',
                visible: true,
                infotype: 'info',
                // type: 'struct',
                type: 'table', //stuct changed to table
                id: shortUUiD.generate(),
                category: 'field',
                children: [
                    {
                        name: 'lat',
                        desc: 'lat',
                        visible: true,
                        axis: 'x',
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'lng',
                        desc: 'lng',
                        visible: true,
                        axis: 'y',
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'type',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'OCTETSTRING',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'label',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'icon',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                ]
            },
            {
                name: 'polygons',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'table',
                id: shortUUiD.generate(),
                category: 'field',
                children: [
                    {
                        name: 'lat',
                        desc: 'lat',
                        visible: true,
                        axis: 'x',
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'lng',
                        desc: 'lng',
                        visible: true,
                        axis: 'y',
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                ]
            },

        ],
        'image': [
            {
                name: 'url',
                desc: 'url',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'title',
                desc: 'title',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'video': [
            {
                name: 'url',
                desc: 'url',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'control-switch': [
            {
                name: 'value',
                desc: 'value',
                visible: true,
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'control-slider': [
            {
                name: 'value',
                desc: 'value',
                visible: true,
                unit: '',
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'control-button': [
            {
                name: 'value',
                desc: 'value',
                visible: true,
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'instance',
                desc: 'instance',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'control-joystick': [
            {
                name: 'value',
                desc: 'value',
                visible: true,
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'model-3d': [
            {
                name: 'url',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'labels',
                desc: '',
                visible: true,
                collection: true,
                infotype: 'info',
                type: 'struct',
                id: shortUUiD.generate(),
                category: 'field',
                children: [
                    {
                        name: 'name',
                        desc: 'Name',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'label',
                        desc: 'Label',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'coords',
                        desc: 'Coordinates',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'type',
                        desc: 'Type',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'urlType',
                        desc: 'Hyperlink Type',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'event',
                        desc: 'Event',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'clusterletType',
                        desc: 'Clusterlet Type',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'instance',
                        desc: 'Instance',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'viewName',
                        desc: 'View Name',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'url',
                        desc: 'Url',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    }
                ]
            }
        ],

        'url-external': [
            {
                name: 'value',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'url',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
        ],

        'url-clusterlet': [
            {
                name: 'value',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'name',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'clusterlet_type',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
        ],

        'url-view': [
            {
                name: 'value',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'instance',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'name',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
        ],
        'scene-3d': [

            {
                name: 'topleftlat',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'double',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'topleftlng',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'double',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'bottomrightlat',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'double',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'bottomrightlng',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'double',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'label',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'terrain',
                desc: 'terrain URL',
                visible: true,
                infotype: 'info',
                type: 'struct',
                id: shortUUiD.generate(),
                category: 'field',
                children: [
                    {
                        name: 'texture',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []

                    },
                    {
                        name: 'heightmap',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []

                    }
                ]
            },
            {
                name: 'objects',
                desc: 'objects within this volume',
                visible: true,
                infotype: 'info',
                type: 'table',
                id: shortUUiD.generate(),
                category: 'field',
                children: [
                    {
                        name: 'lat',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'lng',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'alt',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'double',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'type',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'instance',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'url-clusterlet',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: [
                            {
                                name: 'value',
                                desc: '',
                                visible: true,
                                infotype: 'info',
                                type: 'string',
                                id: shortUUiD.generate(),
                                category: 'field',
                                children: []
                            },
                            {
                                name: 'name',
                                desc: '',
                                visible: true,
                                infotype: 'info',
                                type: 'string',
                                id: shortUUiD.generate(),
                                category: 'field',
                                children: []
                            },
                            {
                                name: 'clusterlet_type',
                                desc: '',
                                visible: true,
                                infotype: 'info',
                                type: 'string',
                                id: shortUUiD.generate(),
                                category: 'field',
                                children: []
                            },
                        ]
                    },
                    {
                        name: 'label',
                        desc: '',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                ]
            },
        ],
        'compass': [
            {
                name: 'direction',
                desc: 'Direction',
                visible: true,
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'content',
                desc: 'Content',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
        'chart-pie-radial': [
            {
                name: 'X',
                desc: 'X axis',
                visible: true,
                axis: 'x',
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: [],
                unit: "X Unit"
            },
            {
                name: 'Y',
                desc: 'Y axis',
                visible: true,
                axis: 'y',
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: [],
                unit: "Y Unit"
            },
            {
                name: 'maxval',
                desc: 'Maximum value',
                visible: true,
                infotype: 'info',
                type: 'UINT32',
                id: shortUUiD.generate(),
                category: 'field',
                children: [],
            }
        ],
        'table-button': [

            {
                name: 'value',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'instance',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'name',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },



        ],
        'table': [
            {
                name: "actions",
                desc: 'Actions',
                unit: "",
                infotype: 'info',
                visible: true,
                category: 'field',
                type: 'drop-down',
                id: shortUUiD.generate(),
                title: "Actions",
                children: []
            }
        ],
        'image-map': [
            {
                name: 'url',
                desc: 'url',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'areas',
                desc: '',
                visible: true,
                infotype: 'info',
                type: 'table',
                id: shortUUiD.generate(),
                category: 'field',
                collection: true,
                children: [
                    {
                        name: 'name',
                        desc: 'Name',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'coords',
                        desc: 'Coordinates',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'shape',
                        desc: 'Shape',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'type',
                        desc: 'Type',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'urlType',
                        desc: 'Hyperlink Type',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'event',
                        desc: 'Event',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'clusterletType',
                        desc: 'Clusterlet Type',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'instance',
                        desc: 'Instance',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'viewName',
                        desc: 'View Name',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    },
                    {
                        name: 'url',
                        desc: 'Url',
                        visible: true,
                        infotype: 'info',
                        type: 'string',
                        id: shortUUiD.generate(),
                        category: 'field',
                        children: []
                    }
                ]
            },
        ],
        'status': [
            {
                name: 'value',
                desc: 'value',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            },
            {
                name: 'type',
                desc: 'type',
                visible: true,
                infotype: 'info',
                type: 'string',
                id: shortUUiD.generate(),
                category: 'field',
                children: []
            }
        ],
    }
}

export const minMaxSchema = {
    minval: {
        title: 'Minimum Value',
        type: 'number',
        default: 0,
        options: {
            layout: 'grid',
            grid_columns: 6
        },
    },
    maxval: {
        title: 'Maximum Value',
        type: 'number',
        default: 100,
        options: {
            layout: 'grid',
            grid_columns: 6
        },
    },

};

export const widthHeightSchema = {
    width: {
        title: 'Width',
        type: "string",
        format: "grid",
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...dimensionValues.map((value) => { return { 'title': value, 'value': value } })],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }],
        options: {
            layout: 'grid',
            grid_columns: 6
        },
        default: 4
    },

    height: {
        title: 'Height',
        type: "string",
        format: "grid",
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...dimensionValues.map((value) => { return { 'title': value, 'value': value } })],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }],
        options: {
            layout: 'grid',
            grid_columns: 6
        },
        default: 3
    },
}

export const mapTypesSchema = {
    mapType: {
        title: 'Map Type',
        type: "string",
        format: "grid",
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...mapTypes.map((ele) => { return { 'title': ele.title, 'value': ele.value } })],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }],
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    },
}

export const unitFieldSchema = {
    unit: {
        title: 'Unit',
        type: 'string',
        format: "grid",
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const defaultFieldSchema = {
    default: {
        title: 'Default',
        type: 'string',
        format: "grid",
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const VisibilitySchema = {
    "visible": {
        title: 'Visibility',
        type: "string",
        enumSource: [{
            source: [{ title: "True", value: "true" }, { title: "False", value: "false" }],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }]
    }
}

export const axisSchema = {
    axis: {
        title: 'Axis',
        type: 'string',
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...axes.map((type) => { return { 'title': type.title, 'value': type.value } })],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }],
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const orientationSchema = {
    orientation: {
        title: 'Orientation',
        type: 'string',
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...orientationOptions.map((type) => { return { 'title': type.title, 'value': type.value } })],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }],
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const stepSchema = {
    step: {
        title: 'Step',
        type: 'string',
        format: "grid",
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const mappingStaticSchema = {
    staticValue: {
        title: 'Static value',
        type: 'string',
        format: "grid",
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}



export const unitSchema = {
    unit: {
        title: 'Unit',
        type: 'string',
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const defaultValSchema = {
   defaultVal: {
        title: 'Default',
        type: 'string',
        options: {
            layout: 'grid',
            grid_columns: 12
        },
   }
}

export const buttonTextSchema = {
    btnText: {
        title: 'Button Text',
        type: 'string',
        options: {
            layout: 'grid',
            grid_columns: 12
        },
    }
}

export const mappingClusterletSchema = function (clusterlets, isFieldRequired) {
    const schema = {
        clusterlet: {
            title: 'Clusterlet',
            type: "string",
            enumSource: [{
                source: [{ title: "Select", value: 'select' }, ...clusterlets.map((clusterlet) => { return { 'title': clusterlet.name, 'value': clusterlet._id } })],
                title: "{{item.title}}",
                value: "{{item.value}}"
            }],
            options: {
                layout: 'grid',
                grid_columns: 3
            },
        },
        instance: {
            title: 'Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 3
            },
        }
    }
    if (isFieldRequired === true) {
        schema.field = {
            title: 'Field',
            type: 'string',
            icon: "fa-check-circle",
            options: {
                icon: "fa-check-circle",
                layout: 'grid',
                grid_columns: 6
            },
        }
    }
    return schema;

}

export const viewNameSchema = {

    viewName: {
        title: 'Please specify a view name, if you want to include a hyperlink to an individual view.',
        type: 'string',
        options: {
            layout: 'grid',
            grid_columns: 4
        },
    },

}

const generateInBuiltTransaction = (clusterlets) => {

    return clusterlets.map(obj => {
        let newObj = {
            ...obj,
            name: `get_${obj.name}`
        }
        return newObj;
    })

}

export const mappingTransactionSchema = function (transactions, isFieldRequired, clusterlets, events = [], delegates = [], isResponseEventsRequired = false, isClusterletRequired = false, fieldName = "", isView=false) {
    let inbuildTransactions = [];
    if (isFieldRequired && clusterlets != undefined) {
        let filteredClusterlets = clusterlets.filter(item => item.type == 2 || item.type == 3)
        inbuildTransactions = generateInBuiltTransaction(filteredClusterlets) || []
    }
    let inbuildTransactionsIds = inbuildTransactions?.map(item => item._id);
    let filteredTransaction = transactions.filter(txn => txn.type == 7)
    const combinedTransactions = isView ? filteredTransaction : [...filteredTransaction, ...inbuildTransactions];
    const filteredCombinedTransactions = combinedTransactions?.sort((a,b) => a.name.localeCompare(b.name)) || [];
    let transactionMappingSchema = [{ name: "Select", _id: 'select' }, ...filteredCombinedTransactions].map((item) => {


        let singleSchema = {
            title: item.name,
            type: "object",
            default: item._id,
            format: "grid",
            properties: {
                [item._id]: { default: item._id, type: 'string', options: { hidden: true } },
            },
            options: {
                layout: 'grid',
                grid_columns: 3
            },
            additionalProperties: false
        };

        let schema = {}

        // schema for datasource mapping
        if (item._id != "select" && isClusterletRequired) {
            // in case of user defined transactions
            if (!inbuildTransactionsIds.includes(item._id)) {
                // Triggering event
                schema.event = {
                    title: 'Event name',
                    type: 'string',
                    readOnly: true,
                    options: {
                        layout: 'grid',
                        grid_columns: 6
                    }
                }

                schema.field = {
                    title: 'Field',
                    type: 'string',
                    icon: "fa-check-circle",
                    options: {
                        icon: "fa-check-circle",
                        layout: 'grid',
                        grid_columns: 4
                    }
                }
            }

            schema.clusterlet = {
                title: 'Target clusterlet',
                type: 'string',
                readOnly: true,
                options: {
                    layout: 'grid',
                    grid_columns: 6
                }
            }
            schema.instance = {
                title: 'Instance',
                default: '{instance}',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 4
                }
            }

            if (inbuildTransactionsIds.includes(item._id)) {
                schema.field = {
                    title: 'Field',
                    type: 'string',
                    icon: "fa-check-circle",
                    options: {
                        icon: "fa-check-circle",
                        layout: 'grid',
                        grid_columns: 12
                    }
                }
            }

        }

        if (item._id != "select" && !isFieldRequired) {
            schema.instance = {
                title: 'Instance',
                default: '{instance}',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 4
                }
            }
        }

        singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...schema } };
        return singleSchema;
    });


    return {
        transaction: {
            title: fieldName == "" ? 'Transaction' : fieldName,
            oneOf: [...transactionMappingSchema],
            options: {
                disable_properties: true,
                layout: 'grid',
                grid_columns: 12
            }
        }
    }

}


export const lineChartTypesSchema = {
    linetype: {
        title: 'Line Type',
        type: "string",
        format: "grid",
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...chartTypes.map((ele) => { return { 'title': ele.title, 'value': ele.value } })],
            title: "{{item.title}}",
            value: "{{item.value}}"
        }],
        options: {
            layout: 'grid',
            grid_columns: 12
        },
        default: 'straight'
    },
}

export const iconSchema = {
    icon: {
        title: 'Icon',
        type: 'string',
        format: 'grid',
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...iconTypes.map((ele) => { return { 'title': ele.title, 'value': ele.value } })],
            title: '{{item.title}}',
            value: '{{item.value}}',
        }],
        options: {
            layout: 'grid',
            grid_columns: 12
        },
        default: 'straight'
    }

}

export const colorschema = {
      textColor: {
        title: 'Text color',
        type: "string",
        format: "color",
        options: {
            layout: 'grid',
            grid_columns: 4
        }
      },
      backgroundColor: {
        title: 'Background color',
        type: "string",
        format: "color",
        options: {
            layout: 'grid',
            grid_columns: 4
        }
      }
}


export const statusTypeSchema = {
    statusType: {
        title: 'StatusType',
        type: 'string',
        format: 'grid',
        enumSource: [{
            source: [{ title: "Select", value: 'select' }, ...statusTypes.map((ele) => { return { 'title': ele.title, 'value': ele.value } })],
            title: '{{item.title}}',
            value: '{{item.value}}',
        }],
        options: {
            layout: 'grid',
            grid_columns: 12
        },
        default: 'straight'
    }

}

export const urlSchema = {
    url: {
        title: 'Url',
        type: 'string',
        options: {
            layout: 'grid',
            grid_columns: 6
        }
    }
}

export const instanceSchema = {
    instance: {
        title: 'Instance',
        type: 'string',
        options: {
            layout: 'grid',
            grid_columns: 6
        }
    }
}

export const viewNameDropdownSchema = (views) => {

    return {
        viewname: {
            title: 'View Name',
            type: "string",
            enumSource: [{
                source: [{ title: "Select", value: 'select' }, ...views.map((view) => { return { 'title': view.name, 'value': view._id } })],
                title: "{{item.title}}",
                value: "{{item.value}}"
            }],
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        }
    }
}

export const urlTypeSchema = function (clusterlets, views) {
    const urlTypes = [{ title: 'Select', value: 'select' },
    { title: 'Hyperblox Clusterlet', value: 'url-clusterlet' },
    { title: 'External Link', value: 'url-external' },
    { title: 'Hyperblox View', value: 'url-view' }
    ]
    let urlTypeOneOfSchema = urlTypes.map((item) => {
        let singleSchema = {
            title: item.title,
            type: "object",
            default: item.value,
            format: "grid",
            properties: {
                [item.value]: { default: item.value, type: 'string', options: { hidden: true } },

            },
            options: {
                layout: 'grid',
                grid_columns: 3
            },
            additionalProperties: false
        };
        const queryParameters = hyperlinkQueryParametersSchema({grid:12});

        if (item.value === 'url-clusterlet') {
            let mappingClusterletSchemaObj = mappingClusterletSchema(clusterlets, false);
            singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...mappingClusterletSchemaObj, queryParameters } };
        }

        if (item.value === 'url-external') {
            singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...urlSchema } };
        }

        if (item.value === 'url-view') {
            const viewNameSchemaObj = viewNameDropdownSchema(views);
            singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...viewNameSchemaObj, ...instanceSchema, queryParameters } };
        }

        return singleSchema;
    });

    return {
        urltype: {
            title: 'Hyperlink Type',
            oneOf: [...urlTypeOneOfSchema],
            options: {
                disable_properties: true,
                layout: 'grid',
                grid_columns: 12
            }
        },
    }

}


export const actionTypeSchema = (transactions, clusterlets, views, delegates, events) => {
    const types = [{ title: "Select", value: 'select' }, { title: "Transaction", value: 'transaction' }, { title: "Hyperlink", value: 'url' }];
    const schema = types.map((item) => {

        let singleSchema = {
            title: item.title,
            type: "object",
            default: item.value,
            properties: {
                [item.value]: { default: item.value, type: 'string', options: { hidden: true } },

            },
            additionalProperties: false
        };
        if (item.value === 'transaction') {
            let mappingTransactionSchemaObj = mappingTransactionSchema(transactions, false, [...clusterlets, ...delegates], events, delegates, true);
            singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...mappingTransactionSchemaObj } };
        }
        if (item.value === 'url') {
            let urlTypeSchemaObj = urlTypeSchema(clusterlets, views)
            singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...urlTypeSchemaObj } };
        }
        return singleSchema;
    });

    return schema;
}


export const urlViewSchema = (views) => {
    return {
        viewname: {
            title: 'View name',
            type: "string",
            enumSource: [{
                source: [{ title: "Select", value: 'select' }, ...(views || []).map(item => ({ title: item.name, value: item._id }))],
                title: "{{item.title}}",
                value: "{{item.value}}"
            }],
            options: {
                input_width: '200px',
                layout: 'grid',
                grid_columns: 12
            }
        },
        instance: {
            title: 'Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 12
            },
        }
    }
}

export const urlClusterletSchema = (clusterlets) => {
    return {
        clusterlettype: {
            title: 'Clusterlet type',
            type: "string",
            enumSource: [{
                source: [{ title: "Select", value: 'select' }, ...(clusterlets|| []).map(item => ({ title: item.name, value: item._id }))],
                title: "{{item.title}}",
                value: "{{item.value}}"
            }],
            options: {
                input_width: '200px',
                layout: 'grid',
                grid_columns: 12
            }
        },
        instance: {
            title: 'Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 12
            },
        }
    }
}

export const urlExternalSchema = {
    url: {
        title: "Url",
        type: "string",
        options: {
            layout: 'grid',
            grid_columns: 12
        }
    }
}



export const urlTypesSchema = (clusterlets, views) => {
    const queryParameters = hyperlinkQueryParametersSchema();

    return [{ title: "Select", value: "" }, ...hyperlinkTypes].map(item => {
        let singleSchema = {
            title: item.title,
            type: "object",
            default: item.value,
            properties: {
                [item.value]: {
                    default: item.value,
                    type: 'string',
                    options: { hidden: true }
                },
            },
            additionalProperties: false
        }

        if (item.value === "urlView") {
            const urlViewSchemaObj = urlViewSchema(views);
            singleSchema = {
                ...singleSchema, 
                properties: {
                    ...singleSchema.properties, ...urlViewSchemaObj, queryParameters
                }
            }
        }

        if (item.value === "urlClusterlet") {
            const urlClusterletSchemaObj = urlClusterletSchema(clusterlets);
            singleSchema = {
                ...singleSchema, 
                properties: {
                    ...singleSchema.properties, ...urlClusterletSchemaObj, queryParameters
                }
            }
        }

        if (item.value === "urlExternal") {
            singleSchema = {
                ...singleSchema, 
                properties: {
                    ...singleSchema.properties, ...urlExternalSchema
                }
            }
        }

        return singleSchema
    });
}

export const optionsForHyperlinkSchema = (clusterlets, views) => {
    return [{ title: "Disable", value: "disable" }, { title: "Enable", value: "enable" }].map(item => {
        let singleSchema = {
            title: item.title,
            type: "object",
            default: item.value,
            properties: {
                [item.value]: {
                    default: item.value,
                    type: 'string',
                    options: { hidden: true }
                },

            },
            additionalProperties: false
        };

        if (item.value === "enable") {
            const urlTypesSchemaObj = urlTypesSchema(clusterlets, views);
            singleSchema = {
                ...singleSchema,
                properties: {
                    ...singleSchema.properties,
                    urlType: {
                        title: "Hyperlink type",
                        oneOf: [...urlTypesSchemaObj],
                        options: {
                            input_width: '200px',
                            disable_properties: true,
                            layout: 'grid',
                            grid_columns: 12
                        }

                    }
                }
            }
        }
        return singleSchema
    });
}

export const hyperlinkSchema = (clusterlets, views) => {
    const optionsForHyperlinkSchemaObj = optionsForHyperlinkSchema(clusterlets, views)
    return {
        hyperlink: {
            title: "Hyperlink",
            oneOf: [...optionsForHyperlinkSchemaObj],
            options: {
                input_width: '200px',
                disable_properties: true,
                layout: 'grid',
                grid_columns: 12
            }
        }
    }
}

export const hyperlinkQueryParametersSchema = (data) => {
    const gridSize = data?.grid || 6
    const schema = {
        title: "Query Parameters",
        type: "array",
        format: "table",
        default: [
            { "Key": "", "Value": "" }
        ],
        items: {
          type: "object",
          title: "Query Parameter",
          additionalProperties: false,
          required: ["Key", "Value"],
          properties: {
            Key:   { "type": "string", "title": "Parameter name" },
            Value: { "type": "string", "title": "Parameter value" }
          }
        },
        options: {
            layout: 'grid',
            grid_columns: gridSize,
        }
    }

    return schema;
}

export const findParentIds = (sections, fields, id) => {
    const getParentIds = (items, id, parents = []) => {
        for (let item of items) {
            if (item._id === id) {
                // If we found the item, collect its parent IDs
                if (item.parent && item.parent.length > 0) {
                    const parentId = item.parent[0].id;
                    const parentType = item.parent[0].type;

                    // Add the parent ID to the list of parents
                    parents.push(parentId);

                    // Recursively find the parent IDs in the appropriate array
                    if (parentType === "section") {
                        return getParentIds(sections, parentId, parents);
                    } else if (parentType === "field") {
                        return getParentIds(fields, parentId, parents);
                    }
                }
                return parents;
            }
        }
        return parents;
    };

    // Try to find the ID in both sections and fields arrays
    let parentIds = getParentIds(sections, id);
    if (parentIds.length === 0) {
        parentIds = getParentIds(fields, id);
    }

    return parentIds;
}


export const htmlFormSchema = (transactions = []) => {
    const sortedTransactions = transactions?.sort((a,b)=> a.name.localeCompare(b.name)) || transactions;

    return {

        gettertransaction: {
            title: 'Getter Transaction',
            type: 'string',
            enumSource: [{
                source: [{ title: 'Select', value: 'select' }, ...sortedTransactions.map((txn) => { return { 'title': txn.name, 'value': txn._id } })],
                title: '{{item.title}}',
                value: '{{item.value}}'
            }],
            options: {
                layout: 'grid',
                grid_columns: 6
            }
        },
        getterinstance: {
            title: 'Getter Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        },
        settertransaction: {
            title: 'Setter Transaction',
            type: 'string',
            enumSource: [{
                source: [{ title: 'Select', value: 'select' }, ...sortedTransactions.map((txn) => { return { 'title': txn.name, 'value': txn._id } })],
                title: '{{item.title}}',
                value: '{{item.value}}'
            }],
            options: {
                layout: 'grid',
                grid_columns: 6
            }
        },
        setterinstance: {
            title: 'Setter Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        },
        buttontext: {
            title: 'Button Text',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 12
            },
        }
    }
}


const getLatestPropertiesForExtendedFields = (actualFields, extendedFields) => {

    const findAcutalField = (id) => {
        return actualFields?.find(item => item?._id == id)
    }


    const updatePropertiesForFields = (fields) => {
        return fields?.map(field => {
            let newObj = {...field}

            const actualField = findAcutalField(field.id)
            
            // updated props
            if(actualField){
                newObj.name = actualField?.name
                newObj.desc = actualField?.attributes?.desc
                newObj.type = actualField?.attributes?.type
            }

            if(field?.children && field?.children?.length > 0 ){
                newObj.children = updatePropertiesForFields(field.children)
            }

            return newObj;
        })
    }

    const updatedExtendedFields = updatePropertiesForFields(extendedFields)
    return updatedExtendedFields;
}



export const refineFieldStructure = (fields, extendedFields)  => {
    
    const fieldMap = new Map(fields.map((field) => [field._id, field]));
  
    function filterNode(node) {
      if (!fieldMap.has(node.id)) {
        return null;
      }
  
      if (node.children && node.children.length > 0) {
        node.children = node.children
          .map(filterNode) 
          .filter((child) => child !== null); 
      }
  
      return node; 
    }
  
    const filteredExtendedFields  = extendedFields
        .map(filterNode)
        .filter((node) => node !== null);
        
        
    return getLatestPropertiesForExtendedFields(fields, filteredExtendedFields) 
  }


// export const refineFieldStructure = (fields, extendedFields, initialParentId=null) => {

//     const fieldMap = new Map(fields.map((field) => [field.name, field]));
  
//     function filterNode(node, currentParentId) {


//       if (!node.id) {
//         const matchingField = fieldMap.get(node.name);
//         if (matchingField && matchingField.parentId === currentParentId) {
//           node.id = matchingField._id;
//         }
//       }
  
  
//       if (node.children && node.children.length > 0) {
//         node.children = node.children
//           .map((child) => filterNode(child, node.id))
//           .filter((child) => child !== null);
//       }
  
//       return node; 
//     }
  
//     return extendedFields
//       .map((node) => filterNode(node, initialParentId))
//       .filter((node) => node !== null);
//   };

const flattenFields = (fields) => {
    try {
      
    let flatten = []
  
    const flattenSchema = (fields) => {
      return fields?.forEach(item => {
        flatten.push(item);
        if(item?.children && item?.children?.length > 0 ){
          flattenSchema(item?.children)
        }
      })
    }
    flattenSchema(fields)
    
    return flatten;
  
    } catch (error) {
      console.error(`Flattening fields schema failed. ${error}`);
    }
  }


/**
 * Recursively sort schema fields by "order"
 * @param {Array} fields - array of field objects
 * @returns {Array} sorted array with children also sorted
 */
export const sortFieldsByOrder = (fields = []) => {
    try {
      return fields
        .map(field => {
          // If field has children, sort them too
          if (Array.isArray(field.children)) {
            field = {
              ...field,
              children: sortFieldsByOrder(field.children)
            };
          }
          return field;
        })
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    } catch (error) {
      console.error(`Error while sorting fields: ${error.message}`);
      return fields;
    }
  };

export const generateUpdatedMessageFields = (extendedFields=[], actualFields=[]) => {
    try {
        const flattenExtendedFields =  extendedFields ? flattenFields(extendedFields) : [];
        const sortedActualFields = sortFieldsByOrder(actualFields)
            
        function generateUpdatedFields(fields) {
            return fields?.map(item => {
                let newObj = {
                    id: item._id,
                    name: item.name,
                    desc: item.attributes.desc,
                    type: item.attributes.type,
                    children: []
                };

                if(item?.attributes?.default && item?.attributes?.default !== "" ){
                    newObj.default = item.attributes.default ;
                }

                if(item?.attributes?.optional ){
                    newObj.optional = item.attributes?.optional;
                }
                if(item?.attributes?.constraint && item?.attributes?.constraint !== "" ){
                    newObj.constraint = item.attributes.constraint ;
                    newObj.defaultConstraint = item.attributes.constraint;
                }

                const ex_field = flattenExtendedFields?.find(ex_item => ex_item.id === item._id);
                if(ex_field){

                    if( ex_field?.optional === true || ex_field?.optional === "true"){
                        newObj.optional = true
                    }else{
                        delete newObj.optional
                    }

                    if( ex_field?.default){
                        newObj.default = ex_field?.default
                    }else{
                        delete newObj.default
                    }
            
                    if( ex_field.masked === true || ex_field.masked == "true"){
                        newObj.masked = true
                    }
                    if( ex_field.readonly == true || ex_field.readonly == "true"){
                        newObj.readonly = true
                    }
            
                    if( ex_field.constraint && ex_field.constraint != ""){
                        newObj.constraint = ex_field.constraint
                    }else{
                        delete newObj.constraint;
                    }
                }

                if(newObj.constraint) newObj.constraint = formatConstraintToDropdownValues(newObj.constraint)
                if(newObj.defaultConstraint) newObj.defaultConstraint = formatConstraintToDropdownValues(newObj.defaultConstraint)


                if (item.children && item.children?.length > 0) {
                    newObj.children = generateUpdatedFields(item?.children);
                }

                return newObj;
            });
        }

        let eventFields = generateUpdatedFields(sortedActualFields);
        // console.log({eventFields})
        return eventFields;


    } catch (error) {
        console.error("Generating updated message fields failed. ", error);
        return [];
    }
}


export const mergeArrays = (formatted, filedList) =>  {
    const mergeHelper = (formattedObj, filedListObj) => {
      // Create a map of children from formatted array for easier lookup
      const formattedChildrenMap = new Map(
        (formattedObj.children || []).map(child => [child.id, child])
      );
  
      // If filedListObj has children, prioritize and recurse
      const mergedChildren = filedListObj.children.map(child => {
        if (formattedChildrenMap.has(child.id)) {
          return mergeHelper(formattedChildrenMap.get(child.id), child);
        }
        return child; // Keep child as-is if not in formatted
      });
  
      // Append any missing children from formatted
      const additionalChildren = (formattedObj.children || []).filter(
        child => !filedListObj.children.some(c => c.id === child.id)
      );
  
      return {
        ...filedListObj,
        children: [...mergedChildren, ...additionalChildren]
      };
    };
  
    const filedListMap = new Map(filedList.map(item => [item.id, item]));
  
    const mergedArray = formatted.map(formattedItem => {
      if (filedListMap.has(formattedItem.id)) {
        return mergeHelper(formattedItem, filedListMap.get(formattedItem.id));
      }
      return formattedItem; // Add formatted item if not in filedList
    });
  
    // Append any items in filedList not in formatted
    const additionalItems = filedList.filter(
      filedItem => !formatted.some(f => f.id === filedItem.id)
    );
  
    return [...mergedArray, ...additionalItems];
  }